import { useEffect, useState } from 'react';

const useBreadcrumb = () => {
  const [showAllPaths, setAllPaths] = useState([]);
  const [activePath, setActivePath] = useState('');

  const currentPath = window.location.pathname;

  const capitalizeAndRemoveSlashes = (str) => {
    const activeLink = str
      .split('/')
      .filter((word) => word !== '')
      .map((word) => {
        const removePlus = word?.split('+').join(' ');
        return removePlus.charAt(0).toUpperCase() + removePlus.slice(1);
      });
    return activeLink;
  };

  useEffect(() => {
    if (currentPath !== '/') {
      const splitPath = capitalizeAndRemoveSlashes(decodeURI(currentPath));
      // Strip URL-based pagination segments (e.g. /page/5) from the trail.
      const trimmedPath = [];
      for (let i = 0; i < splitPath.length; i += 1) {
        if (splitPath[i] === 'Page' && /^\d+$/.test(splitPath[i + 1] ?? '')) {
          i += 1;
          continue;
        }
        trimmedPath.push(splitPath[i]);
      }
      const activePage = trimmedPath[trimmedPath.length - 1];
      trimmedPath.unshift('Home');
      setActivePath(activePage);
      setAllPaths(trimmedPath);
    }
  }, [currentPath]);

  return { activePath, showAllPaths };
};

export default useBreadcrumb;
